import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationFormApi } from '@api/btlApplicationForm/btlApplicationFormApi';
import { BtlApplication } from '../../../api/btlApplicationForm/types';

export const useBtlApplicationInProgressById = (applicationId: string): UseQueryResult<BtlApplication> =>
  useQuery(['btl-application-in-progress', applicationId], () =>
    applicationId ? btlApplicationFormApi.getApplicationInProgress(applicationId) : null,
  );
